import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";
class ZoneTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  renderSortHeader = (label, sortKey) => {
    const { onSort, sortDirection, sortKey: activeSortKey } = this.props;
    const active = activeSortKey === sortKey;
    const iconClass = active && sortDirection === "desc"
      ? "fa fa-sort-down"
      : active
        ? "fa fa-sort-up"
        : "fa fa-sort";

    return (
      <button
        className={`depot-sort-button ${active ? "active" : ""}`}
        onClick={() => onSort(sortKey)}
        type="button"
      >
        {label}
        <i className={iconClass}></i>
      </button>
    );
  };

  renderStatus = (status) => {
    const active = status === 1 || status === "Active";

    return (
      <span className={`zone-status-pill ${active ? "active" : "disabled"}`}>
        {active ? "Active" : "Disabled"}
      </span>
    );
  };

  renderVisibility = (isPrivate) => {
    return (
      <span className={`zone-visibility-pill ${isPrivate ? "private" : "public"}`}>
        {isPrivate ? "Private" : "Public"}
      </span>
    );
  };

  render() {
    const { depots } = this.props;
    return (
      <Table className="depot-table zone-table" responsive>
        <thead>
          <tr>
            <th>{this.renderSortHeader("Name", "name")}</th>
            <th>{this.renderSortHeader("Customer", "customerName")}</th>
            <th>{this.renderSortHeader("Address", "address")}</th>
            <th>{this.renderSortHeader("Description", "description")}</th>
            <th>{this.renderSortHeader("Visibility", "private")}</th>
            <th>{this.renderSortHeader("Status", "status")}</th>
            <th className="zone-updated-heading">{this.renderSortHeader("Updated", "dbUpdated")}</th>
            <th className="zone-actions-heading"></th>
          </tr>
        </thead>
        <tbody>
          {depots.length === 0 && (
            <tr>
              <td className="depot-empty" colSpan="8">
                No points of interest match your search.
              </td>
            </tr>
          )}
          {depots.map((depot, index) => {
            return (
              <tr key={index}>
                <td>
                  <strong>{depot.name || "-"}</strong>
                </td>
                <td>
                  <a
                    className="depot-customer-link"
                    onClick={() =>
                      localStorage.setItem(
                        "customer",
                        JSON.stringify({
                          customerId: depot.customerId,
                          customerName: depot.customerName,
                        })
                      )
                    }
                    href={`/zones?customerId=${depot.customerId}&customerName=${depot.customerName}`}
                  >
                    {depot.customerName || "-"}
                  </a>
                </td>
                <td>{depot.address || "-"}</td>
                <td>{depot.description || "-"}</td>
                <td>{this.renderVisibility(depot.private)}</td>
                <td>{this.renderStatus(depot.status)}</td>
                <td className="zone-updated-cell">{depot.dbUpdated ? utcToLocal(depot.dbUpdated) : "-"}</td>

                <td className="depot-actions zone-actions-cell">
                  <Link to={`/editZone/${depot.id}`}>Edit</Link>
                  <Link to={`/zoneDetails/${depot.id}`}>Details</Link>
                  <Link to={`/deleteZone/${depot.id}`}>Delete</Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default ZoneTable;
